import { render, staticRenderFns } from "./DeleteField.vue?vue&type=template&id=3b7c038a&scoped=true"
import script from "./DeleteField.vue?vue&type=script&lang=js"
export * from "./DeleteField.vue?vue&type=script&lang=js"
import style0 from "./DeleteField.vue?vue&type=style&index=0&id=3b7c038a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7c038a",
  null
  
)

export default component.exports